import axios from "axios";

import { API_BASE_URL } from "src/constants";
import { setSession } from "./jwt";

const axiosInstance = axios.create({
  baseURL: API_BASE_URL,
  // withCredentials: true,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalConfig = error.config;

    if (error.response.status === 401) {
      if (
        originalConfig.url.indexOf("/refreshtoken") === -1 &&
        error.response.data.message ===
          "Token invalid or expired. Please renew it."
      ) {
        // console.log("A: ", error.response, originalConfig);
        const originUrl = originalConfig.url;
        originalConfig.url = "/members/refreshtoken";
        originalConfig.headers.Authorization = `Bearer ${localStorage.getItem(
          "refreshToken"
        )}`;
        const _response = await axiosInstance(originalConfig);
        setSession(_response.data.access_token, _response.data.refresh_token);
        originalConfig.url = originUrl;
        originalConfig.headers.Authorization = `Bearer ${_response.data.access_token}`;
        return axiosInstance(originalConfig);
      } else if (originalConfig.url.indexOf("/refreshtoken") !== -1) {
        setSession(null);
        window.location = "/auth/signin";
      }
      // console.log("B: ", error.response, originalConfig);
    }

    return Promise.reject(
      error.response ? error.response : "Something went wrong"
    );
  }
);

export default axiosInstance;
